module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5ff8c38","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/configuracoes/Main.vue
// module id = 1846
// module chunks = 17